export default {"src":"/_next/static/media/InvertedHorizontalLogo.f30b2478.svg","height":24,"width":122,"blurWidth":0,"blurHeight":0};